import React, {Component} from 'react';

import {prettyNumber, prettyDollars, percent} from 'js/common/string_helper';

// Components
import WrapUpAnalyticsCard from './wrap_up_analytics_card';

const pictureImg = require('images/admin/campaign_wrap_up/icons/icon-picture.png');
const userImg = require('images/admin/campaign_wrap_up/icons/icon-user.png');
const engagementImg = require('images/admin/campaign_wrap_up/icons/icon-engagement.png');
const engagementRateImg = require('images/admin/campaign_wrap_up/icons/icon-engagementrate.png');
const ecpccImg = require('images/admin/campaign_wrap_up/icons/icon-ecpcc.png');
const ecpeImg = require('images/admin/campaign_wrap_up/icons/icon-ecpe.png');
const flagImg = require('images/admin/campaign_wrap_up/icons/icon-100.png');

const {CampaignType} = window.sn.enums;

class CampaignWrapUpAnalyticsContainer extends Component {
    displayEcpxCard = () => {
        const {renderForPdf, objectiveBidType, getAssetPath} = this.props;

        if (objectiveBidType === 'cpe') {
            return (
                <WrapUpAnalyticsCard
                    icon={getAssetPath(ecpeImg)}
                    data={prettyDollars(this.props.ecpx)}
                    subtitle="eCPE"
                    helpText={
                        'The effective price you are paying for your primary metric (CPE or CPCC) as determined at the end of the campaign'
                    }
                    renderForPdf={renderForPdf}
                />
            );
        }

        if (objectiveBidType === 'cpcc') {
            return (
                <WrapUpAnalyticsCard
                    icon={getAssetPath(ecpccImg)}
                    data={prettyDollars(this.props.ecpx, 0)}
                    subtitle="eCPCC"
                    helpText={
                        'The effective price you are paying for your primary metric (CPE or CPCC) as determined at the end of the campaign'
                    }
                    renderForPdf={renderForPdf}
                />
            );
        }

        return null;
    };

    getEngagementsHelpText = () => {
        const {campaignType, showVideoViews} = this.props;

        switch (campaignType) {
            case CampaignType.INSTAGRAM:
                return showVideoViews ? 'Likes + Comments + Video Views' : 'Likes + Comments';
            case CampaignType.TWITTER:
                return 'Retweets + Favorites';
            case CampaignType.SNAPCHAT:
                return 'Video Views';
            case CampaignType.YOUTUBE:
                return 'Likes + Comments + Video Views';
            default:
                return 'Total of likes and comments across a campaign; these vary across platforms';
        }
    };

    render() {
        const {renderForPdf, getAssetPath} = this.props;
        const ecpx = this.displayEcpxCard();
        const engagementsHelpText = this.getEngagementsHelpText();

        return (
            <div className="analytics-cards-container">
                <div className="analytics-cards-row-1">
                    <WrapUpAnalyticsCard
                        icon={getAssetPath(pictureImg)}
                        data={this.props.contentCount}
                        subtitle="pieces of unique branded content"
                        helpText={
                            'Total pieces of content that have been submitted to this campaign'
                        }
                        renderForPdf={renderForPdf}
                    />
                    <WrapUpAnalyticsCard
                        icon={getAssetPath(userImg)}
                        data={prettyNumber(this.props.totalReach, 1)}
                        subtitle="users reached"
                        helpText={
                            'Total audience size that could be exposed to your content, this is calculated by the sum of total followers across all creators in the campaign'
                        }
                        renderForPdf={renderForPdf}
                    />
                    <WrapUpAnalyticsCard
                        icon={getAssetPath(engagementImg)}
                        data={prettyNumber(this.props.engagements, 1)}
                        subtitle="engagements"
                        helpText={engagementsHelpText}
                        renderForPdf={renderForPdf}
                    />
                </div>
                <div className="analytics-cards-row-2">
                    <WrapUpAnalyticsCard
                        icon={getAssetPath(engagementRateImg)}
                        data={percent(this.props.engagementRate)}
                        subtitle="engagement rate"
                        helpText="(Total Engagements / Total Reach) * 100"
                        renderForPdf={renderForPdf}
                    />
                    {ecpx}
                    <WrapUpAnalyticsCard
                        icon={getAssetPath(flagImg)}
                        data={percent(this.props.percentDelivered, 0)}
                        subtitle="campaign delivered"
                        helpText={
                            "The percentage of delivery based off the campaign's primary metric (CPE or CPCC)"
                        }
                        renderForPdf={renderForPdf}
                    />
                </div>

                {/*STYLES*/}

                <style>{`
                    .analytics-cards-container {
                        width: 100%;
                        padding-bottom: 40px;
                    }

                    .analytics-cards-row-1 {
                        width: 90%;
                    }

                    .analytics-cards-row-2 {
                        width: 90%
                    }
                `}</style>

                {/*STYLE FOR WEB*/}
                {!renderForPdf ? (
                    <style>{`
                        .analytics-cards-container {
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        }

                        .analytics-cards-row-1 {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }

                        .analytics-cards-row-2 {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    `}</style>
                ) : null}

                {/*STYLE FOR PDF*/}
                {renderForPdf ? (
                    <style>{`
                        .analytics-cards-container {
                            text-align: center;
                        }

                        .analytics-cards-row-1 {
                            margin: auto;
                        }

                        .analytics-cards-row-2 {
                            margin: auto;
                        }
                    `}</style>
                ) : null}
            </div>
        );
    }
}

CampaignWrapUpAnalyticsContainer.propTypes = {};

export default CampaignWrapUpAnalyticsContainer;



// WEBPACK FOOTER //
// ./campaign_analytics/campaign_wrap_up/campaign_wrap_up_analytics/campaign_wrap_up_analytics_container.js